export const Base_URL = 'https://api.nvcti.in';
// export const Base_URL = 'http://localhost:4000';
export const imageBaseURL = "https://api.nvcti.in/uploads/";
